import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { 
  FormControl, 
  TextField, 
  Button, 
  Box, 
  Alert, 
  AlertTitle, 
  Stack,
  MenuItem,
  Select,
  Typography,
  Paper,
  IconButton,
  InputAdornment,
  Divider,
  Avatar,
  Chip
} from "@mui/material";

import { 
  CalendarToday, 
  AccessTime, 
  Person, 
  ArrowBackIos,
  Check,
  Phone,
  Notes,
  Event,
  Schedule
} from "@mui/icons-material";
import {
  collection,
  doc,
  onSnapshot,
  query,
  serverTimestamp,
  updateDoc,
  where,
  orderBy
} from "firebase/firestore";
import { db } from "../../../firebaseConfig/firebase";
import axios from "axios";

function Reschedule() {
  let navigate = useNavigate();
  const state = useLocation();
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [name, setName] = useState(state.state.name);
  const [phNumber] = useState(state.state.phoneNumber);
  const [time, setTime] = useState(state.state.time);
  const [duration, setDuration] = useState(state.state.duration);
  const [reason, setReason] = useState(state.state.reason);
  const [ptId] = useState(state.state.patientId);
  const [date, setDate] = useState(new Date(Date.now()));
  const [dateAppointments, setDateAppointments] = useState([]);
  let datew = JSON.stringify(date);
  datew = datew.slice(1, 11);

  let originalDate = datew;
  let splitDate = originalDate.split("-");
  let convertedDate = splitDate[2] + "-" + splitDate[1] + "-" + splitDate[0];

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate required fields
    if (!time || time.trim() === "" || time === "Choose a Time") {
      setAlertType("error");
      setAlertMessage("Please select an Appointment Time before rescheduling");
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), 3000);
      return;
    }

    if (!reason || reason.trim() === "") {
      setAlertType("error");
      setAlertMessage("Please enter Reason for Appointment");
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), 3000);
      return;
    }

    if (!duration || duration.trim() === "") {
      setAlertType("error");
      setAlertMessage("Please select Duration");
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), 3000);
      return;
    }

    const militaryTime = time;
    const hours = Math.floor(militaryTime / 100);
    const minutes = militaryTime % 100;
    const timeString = `${hours % 12 || 12}:${minutes
      .toString()
      .padStart(2, "0")} ${hours < 12 ? "AM" : "PM"}`;

    console.log(name, convertedDate, time, timeString, ptId, reason);

    try {
    const updateAppointment = doc(db, "AppointmentDetails", state.state.docid);
    await updateDoc(updateAppointment, {
      date: datew,
      reason: reason,
      time: time,
      duration: duration,
      timeString: timeString,
      updatedCreated: serverTimestamp(),
        isRescheduled: true,
        rescheduledAt: serverTimestamp(),
        originalDate: state.state.date || "",
        originalTime: state.state.time || "",
        originalTimeString: state.state.timeString || ""
      });
    } catch (firestoreError) {
      console.error("Firestore update failed:", firestoreError);
      setAlertType("error");
      setAlertMessage("Failed to update appointment. Please try again.");
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), 3000);
      return;
    }

    try {
      axios
        .post(
          "https://expressapi-avwxc4hazq-uc.a.run.app/rescheduledAppointment",
          {
            name: state.state.name,
            phno: phNumber,
            convertedDate: convertedDate,
            timeString: timeString,
          },
          {
            headers: {
              "Content-type": "application/json; charset=UTF-8",
            },
          }
        )
        .then((res) => {
          console.log(res);
        });
    } catch (whatsappError) {
      console.error("WhatsApp notification failed:", whatsappError);
      // Continue even if WhatsApp fails
    }

    setAlertType("success");
    setAlertMessage("Appointment rescheduled successfully!");
    setShowAlert(true);

    setName("");
    setTime("");
    setDate("");
    setReason("");
    setDuration("");

    setTimeout(() => {
      setShowAlert(false);
      navigate(-1);
    }, 1500);
  };

  const handleChangeTime = (event) => {
    setTime(event.target.value);
  };
  const handleChangeDuration = (event) => {
    setDuration(event.target.value);
  };


  // Time options for dropdown
  const timeOptions = [
    { value: "", label: "Choose a Time" },
    { value: "1000", label: "10:00 AM" },
    { value: "1030", label: "10:30 AM RCT" },
    { value: "1100", label: "11:00 AM" },
    { value: "1130", label: "11:30 AM" },
    { value: "1200", label: "12:00 PM" },
    { value: "1230", label: "12:30 PM RCT" },
    { value: "1300", label: "01:00 PM RCT" },
    { value: "1600", label: "04:00 PM RCT" },
    { value: "1630", label: "04:30 PM" },
    { value: "1700", label: "05:00 PM" },
    { value: "1730", label: "05:30 PM" },
    { value: "1800", label: "06:00 PM RCT" },
    { value: "1830", label: "06:30 PM" },
    { value: "1900", label: "07:00 PM" },
    { value: "1930", label: "07:30 PM" },
  ];

  // Duration options for dropdown
  const durationOptions = [
    { value: "", label: "Select Duration" },
    { value: "15 Mins", label: "15 Minutes" },
    { value: "30 Mins", label: "30 Minutes" },
    { value: "45 Mins", label: "45 Minutes" },
    { value: "1 Hr", label: "1 Hour" },
    { value: "1.5Hrs", label: "1.5 Hours" },
    { value: "2 Hrs", label: "2 Hours" },
    { value: "2.5 Hrs", label: "2.5 Hours" },
    { value: "3 Hrs", label: "3 Hours" },
  ];

  // Fetch appointments for selected date
  useEffect(() => {
    if (datew) {
      const appointmentData = collection(db, "AppointmentDetails");
      
      const qd = query(
        appointmentData,
        where("date", "==", datew),
        orderBy("time", "asc")
      );

    const unsub = onSnapshot(qd, (snap) => {
      let newArray = [];

      snap.forEach((doc) => {
        newArray.push({
          ...doc.data(),
            id: doc.get("patientId"),
            ptName: doc.get("name"),
          docid: doc.id,
            timeString: doc.get("timeString"),
          phoneNumber: doc.get("phNumber"),
            duration: doc.get("duration"),
            reason: doc.get("reason"),
            appointmentDate: doc.get("date"),
            appointmentTime: doc.get("time"),
          created: doc.get("created"),
            isRescheduled: doc.get("isRescheduled"),
            type: doc.get("type"),
        });
      });

        console.log("Appointments for date:", newArray);
        setDateAppointments(newArray);
    });

    return () => {
      unsub();
    };
    }
  }, [datew]);

  // Initialize patient data from state (no need for search since we're rescheduling existing appointment)
  useEffect(() => {
    if (state.state) {
      // Patient data is already available from state, no need to set it
    }
  }, [state.state]);

  return (
    <Box sx={{ 
      backgroundColor: "#f5f8fa", 
      height: "100vh",
      display: "flex",
      flexDirection: "column"
    }}>
      {/* Header */}
      <Box
        sx={{
          height: "64px",
          backgroundColor: "#0a0d25",
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 2,
          borderBottomRightRadius: "20px",
          borderBottomLeftRadius: "20px",
          flexShrink: 0
        }}
      >
        <IconButton 
          onClick={() => navigate(-1)} 
          sx={{ color: "white" }}
        >
          <ArrowBackIos />
        </IconButton>
        <Typography variant="h6" sx={{ fontSize: "1.1rem" }}>
          Reschedule Appointment
        </Typography>
        <Typography variant="body1" sx={{ fontWeight: "600" }}>
          {convertedDate}
        </Typography>
      </Box>

      {/* Alert */}
      {showAlert && (
        <Stack
          sx={{ 
            width: '100%', 
            position: 'absolute', 
            zIndex: '999',
            top: "64px" 
          }} 
          spacing={2}
        >
          <Alert 
            severity={alertType}
            sx={{
              borderRadius: "0px 0px 8px 8px",
              boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
            }}
          >
            <AlertTitle>{alertType === "success" ? "Success" : "Error"}</AlertTitle>
            {alertMessage}
          </Alert>
        </Stack>
      )}

      {/* Main Content */}
      <Box sx={{ 
        p: 2, 
        height: { xs: "auto", md: "calc(100vh - 64px)" },
        overflow: { xs: "visible", md: "hidden" },
        display: "flex",
        flexDirection: "column"
      }}>
        <Box sx={{ 
          display: "flex", 
          flexDirection: { xs: "column", md: "row" },
          height: { xs: "auto", md: "100%" },
          overflow: { xs: "visible", md: "hidden" }
        }}>
          {/* Form Section */}
          <Box sx={{ 
            flexBasis: { xs: "auto", md: "65%" },
            flexGrow: { xs: 0, md: 1 },
            flexShrink: 0,
            mr: { xs: 0, md: 2 },
            mb: { xs: 2, md: 0 },
            height: { xs: "auto", md: "100%" },
            overflow: { xs: "visible", md: "auto" },
            position: "relative"
          }}>
            <Paper
              elevation={0}
              sx={{
                borderRadius: "16px",
                p: 3,
                boxShadow: "0 2px 12px rgba(0,0,0,0.08)"
              }}
            >
              <Typography variant="h6" sx={{ mb: 3, fontWeight: 600, color: "#0a0d25" }}>
                Reschedule Appointment
              </Typography>

        <form noValidate autoComplete="off" onSubmit={handleSubmit}>
                {/* Patient Name Field */}
                <Box sx={{ mb: 3 }}>
          <TextField
                    id="patient-name"
            label="Patient Name"
                    value={name}
                    variant="outlined"
            fullWidth
            InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Person color="action" />
                        </InputAdornment>
                      ),
              readOnly: true,
                      sx: {
                        backgroundColor: "#f5f5f5"
                      }
            }}
          />
                </Box>

                {/* Reason Field */}
                <Box sx={{ mb: 3 }}>
          <TextField
                    id="reason"
                    label="Reason for Appointment"
                    value={reason}
            onChange={(e) => setReason(e.target.value)}
                    variant="outlined"
            fullWidth
                    multiline
                    rows={2}
            required
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start" sx={{ alignSelf: "flex-start", pt: 1 }}>
                          <Notes color="action" />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>

                {/* Appointment Details */}
                <Paper
                  elevation={0}
                  sx={{
                    borderRadius: "12px",
                    p: 2.5,
                    mb: 3,
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #e9ecef"
                  }}
                >
                  <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600, color: "#0a0d25" }}>
                    New Appointment Details
                  </Typography>

                  {/* Date Selection */}
                  <Box 
                    sx={{ 
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                      mb: 2.5
              }}
            >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <CalendarToday sx={{ color: "#1976d2", mr: 1, fontSize: "1.1rem" }} />
                      <Typography sx={{ color: "#666565", fontWeight: 500 }}>
                Appointment Date:
                      </Typography>
                    </Box>
              <TextField
                      type="date"
                      variant="outlined"
                      size="small"
                      defaultValue={datew}
                      onChange={(e) => setDate(e.target.value)}
                      InputProps={{
                        sx: {
                  backgroundColor: "white",
                          borderRadius: "8px",
                          "& fieldset": {
                            borderColor: "#e0e0e0"
                          }
                        }
                      }}
                      sx={{ width: "180px" }}
                    />
                  </Box>
                  
                  {/* Mobile Only: Appointments List */}
                  <Box sx={{ 
                    display: { xs: "block", md: "none" }, 
                    mb: 2.5,
                    mt: 2,
                    border: "1px solid #e0e0e0",
                    borderRadius: "8px",
                    bgcolor: "#fff",
                    p: 1.5
                  }}>
                    <Typography variant="caption" sx={{ display: "block", mb: 1, color: "#666", fontWeight: 500 }}>
                      Existing appointments on selected date:
                    </Typography>
                    <Box sx={{ maxHeight: "200px", overflowY: "auto" }}>
                      {dateAppointments.length > 0 ? dateAppointments.map((apt, index) => (
                        <Paper
                          key={index}
                          elevation={0}
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            backgroundColor: "white",
                            borderRadius: "12px",
                            border: "1px solid #f0f0f0",
                            mb: 1,
                            p: 1.5,
                            transition: "all 0.2s ease",
                            "&:hover": {
                              boxShadow: "0 4px 8px rgba(0,0,0,0.05)",
                            },
                          }}
                        >
                          <Box display="flex" alignItems="center" mb={0.5}>
                            <Avatar
                              sx={{
                                width: 36,
                                height: 36,
                                fontSize: "0.75rem",
                                bgcolor: apt.type === "pending" ? "#ffebee" : apt.isRescheduled ? "#fff3e0" : "#e3f2fd",
                                color: apt.type === "pending" ? "#d32f2f" : apt.isRescheduled ? "#f57c00" : "#1976d2",
                                mr: 1.5,
                              }}
                            >
                              {apt.timeString.split(" ")[0] || apt.time.split(" ")[0]}
                            </Avatar>
                            <Box flexGrow={1}>
                              <Typography variant="subtitle2" fontWeight={600} color="#111">
                                {apt.ptName || apt.name}
                              </Typography>
                              <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                mt={0.5}
                              >
                                <Typography variant="caption" color="text.secondary">
                                  {apt.timeString}
                                </Typography>
                                <Box display="flex" gap={0.5}>
                                  {apt.type === "pending" && (
                                    <Chip
                                      label="Pending"
                                      size="small"
                                      sx={{
                                        height: "20px",
                                        fontSize: "0.675rem",
                                        bgcolor: "#ffebee",
                                        color: "#d32f2f",
                                      }}
                                    />
                                  )}
                                  {apt.isRescheduled && (
                                    <Chip
                                      label="Rescheduled"
                                      size="small"
                                      sx={{
                                        height: "20px",
                                        fontSize: "0.675rem",
                                        bgcolor: "#fff3e0",
                                        color: "#f57c00",
                                      }}
                                    />
                                  )}
                                  <Chip
                                    label={apt.duration}
                                    size="small"
                                    sx={{
                                      height: "20px",
                                      fontSize: "0.675rem",
                                      bgcolor: "#f5f5f5",
                                      color: "#555",
                                    }}
                                  />
                                </Box>
                              </Box>
                            </Box>
                          </Box>
                          <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{ pl: 6.5 }}
                          >
                            {apt.reason}
                          </Typography>
                        </Paper>
                      )) : (
                        <Typography variant="body2" sx={{ textAlign: "center", py: 2, color: "#666" }}>
                          No appointments on this date
                        </Typography>
                      )}
                    </Box>
                  </Box>

                  {/* Time Selection */}
                  <Box 
                    sx={{ 
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                      mb: 2.5
              }}
            >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <AccessTime sx={{ color: "#1976d2", mr: 1, fontSize: "1.1rem" }} />
                      <Typography sx={{ color: "#666565", fontWeight: 500 }}>
                        Appointment Time <span style={{ color: "red", fontWeight: "bold" }}>*</span>:
                      </Typography>
                    </Box>
                    
                    <FormControl sx={{ width: "180px" }} required error={!time}>
                      <Select
                        value={time}
                        onChange={handleChangeTime}
                        displayEmpty
                        required
                        size="small"
                        sx={{
                          backgroundColor: "white",
                          borderRadius: "8px",
                          "& fieldset": {
                            borderColor: !time ? "#d32f2f" : "#e0e0e0"
                          }
                        }}
                      >
                        {timeOptions.map(option => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>

                  {/* Duration Selection */}
                  <Box 
                    sx={{ 
                display: "flex",
                justifyContent: "space-between",
                      alignItems: "center"
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Schedule sx={{ color: "#1976d2", mr: 1, fontSize: "1.1rem" }} />
                      <Typography sx={{ color: "#666565", fontWeight: 500 }}>
                Duration:
                      </Typography>
                    </Box>
                    
                    <FormControl sx={{ width: "180px" }}>
                      <Select
                value={duration}
                onChange={handleChangeDuration}
                        displayEmpty
                        size="small"
                        sx={{
                          backgroundColor: "white",
                          borderRadius: "8px",
                          "& fieldset": {
                            borderColor: "#e0e0e0"
                          }
                        }}
                      >
                        {durationOptions.map(option => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Paper>

                {/* Submit Button */}
            <Button
              type="submit"
              variant="contained"
                  fullWidth
                  startIcon={<Check />}
                  sx={{
                    py: 1.2,
                    backgroundColor: "#0a0d25",
                    borderRadius: "8px",
                    textTransform: "none",
                    fontWeight: 600,
                    boxShadow: "0 2px 10px rgba(10,13,37,0.3)",
                    "&:hover": {
                      backgroundColor: "#161d4d"
                    }
                  }}
                >
                  Reschedule Appointment
                </Button>
              </form>
            </Paper>
          </Box>
          
          {/* Appointments Section */}
          <Box sx={{ 
            flexBasis: { xs: "auto", md: "35%" },
            flexGrow: 1,
            overflow: "auto",
            display: { xs: "none", md: "block" },
            height: { md: "calc(100vh - 80px)" },
            position: "sticky",
            top: "70px"
          }}>
            <Paper
              elevation={0}
              sx={{
                borderRadius: "16px",
                p: 3,
                boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                maxHeight: "calc(100vh - 80px)"
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <Event sx={{ color: "#1976d2", mr: 1 }} />
                <Typography variant="h6" sx={{ fontWeight: 600, color: "#0a0d25" }}>
                  Appointments on {convertedDate}
                </Typography>
              </Box>
              
              <Divider sx={{ mb: 2 }} />
              
              <Box sx={{ 
                flex: 1,
                overflowY: "auto",
                pr: 1
              }}>
                {dateAppointments.length > 0 ? (
                  dateAppointments.map((apt, index) => (
                    <Paper
                      key={index}
                      elevation={0}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        backgroundColor: "white",
                        borderRadius: "12px",
                        border: "1px solid #f0f0f0",
                        mb: 2,
                        p: 2,
                        transition: "all 0.2s ease",
                        "&:hover": {
                          boxShadow: "0 4px 8px rgba(0,0,0,0.05)",
                        },
                      }}
                    >
                      <Box display="flex" alignItems="center" mb={1}>
                        <Avatar
                          sx={{
                            width: 40,
                            height: 40,
                            fontSize: "0.8rem",
                            bgcolor: apt.type === "pending" ? "#ffebee" : apt.isRescheduled ? "#fff3e0" : "#e3f2fd",
                            color: apt.type === "pending" ? "#d32f2f" : apt.isRescheduled ? "#f57c00" : "#1976d2",
                            mr: 1.5,
                          }}
                        >
                          {apt.timeString.split(" ")[0] || apt.time.split(" ")[0]}
                        </Avatar>
                        <Box flexGrow={1}>
                          <Typography variant="subtitle2" fontWeight={600} color="#111">
                            {apt.ptName || apt.name}
                          </Typography>
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            mt={0.5}
                          >
                            <Typography variant="caption" color="text.secondary">
                              {apt.timeString}
                            </Typography>
                            <Box display="flex" gap={0.5}>
                              {apt.type === "pending" && (
                                <Chip
                                  label="Pending"
                                  size="small"
                                  sx={{
                                    height: "20px",
                                    fontSize: "0.675rem",
                                    bgcolor: "#ffebee",
                                    color: "#d32f2f",
                                  }}
                                />
                              )}
                              {apt.isRescheduled && (
                                <Chip
                                  label="Rescheduled"
                                  size="small"
                                  sx={{
                                    height: "20px",
                                    fontSize: "0.675rem",
                                    bgcolor: "#fff3e0",
                                    color: "#f57c00",
                                  }}
                                />
                              )}
                              <Chip
                                label={apt.duration}
                                size="small"
                                sx={{
                                  height: "20px",
                                  fontSize: "0.675rem",
                                  bgcolor: "#f5f5f5",
                                  color: "#555",
                                }}
                              />
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                      
                      <Box sx={{ pl: 7 }}>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                        >
                          {apt.reason}
                        </Typography>
                        
                        {apt.phoneNumber && (
                          <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                            <Phone sx={{ fontSize: "0.875rem", color: "#9e9e9e", mr: 0.5 }} />
                            <Typography variant="caption" color="text.secondary">
                              {apt.phoneNumber}
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    </Paper>
                  ))
                ) : (
                  <Box 
                    sx={{ 
                      display: "flex", 
                      flexDirection: "column", 
                      alignItems: "center", 
                      justifyContent: "center",
                      height: "200px",
                      p: 3
                    }}
                  >
                    <Event sx={{ fontSize: "3rem", color: "#e0e0e0", mb: 2 }} />
                    <Typography variant="body1" sx={{ color: "#666", textAlign: "center" }}>
                      No appointments scheduled for this date
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#999", textAlign: "center", mt: 1 }}>
                      Perfect time to reschedule!
                    </Typography>
                  </Box>
                )}
              </Box>
            </Paper>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default Reschedule;
